import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  Label,
  // Brush,
} from "recharts"

import CustomLegend from "./CustomLegend.js"

export default function Charts({
  xAxis,
  log,
  getMax,
  filtered,
  citiesName,
  handleMouseOver,
  handleMouseOut,
  handleclick,
  tempFilter,
  showCity,
  tempHover,
  french,
  levelToColor,
  moment,
  cityColors,
  scaleChoice,
  setScaleChoice,
  startIndexDataviz,
  endIndexDataviz,
}) {
  const filterRange = (weeks) =>
    weeks.filter(
      (week, index) => index >= startIndexDataviz && index <= endIndexDataviz,
    )

  const rangeFiltered = filterRange(filtered)

  const zoomMax = getMax(rangeFiltered)

  const easters = [
    {
      x: "2022-09-05",
      fr: "❝C'est un rhume❞",
      en: "❝It's mild❞",
      position: "insideBottom",
    },
    {
      x: "2022-10-17",
      fr: "❝un soubressaut qui sait❞",
      en: "❝just a bump who knows❞",
      position: "center",
    },
    {
      x: "2022-12-12",
      fr: "❝Personne n'aurait pu prévoir ça❞",
      en: "❝No one could have foreseen this❞",
      position: "insideTop",
    },
    {
      x: "2023-02-13",
      fr: "❝C'est saisonnier❞",
      en: "❝It's seasonal❞",
      position: "insideBottom",
    },
    {
      x: "2023-05-01",
      fr: "❝5 mois de mémoire immunitaire, incroyable❞",
      en: "❝5 months of immune memory, incredible❞",
      position: "center",
    },
    {
      x: "2023-07-10",
      fr: "❝C'est terminé❞",
      en: "❝It's over❞",
      position: "insideBottom",
    },

    {
      x: "2023-12-18",
      fr: "❝Personne n'aurait pu prédire ça❞",
      en: "❝No one could have predicted this❞",
      position: "insideTop",
    },
    {
      x: "2023-09-04",
      fr: "❝Imprévisible cocktail des variants d'été❞",
      en: "❝Summer variant soup was unpredictable❞",
      position: "center",
    },
    {
      x: "2024-04-08",
      fr: "❝Immunité de masse❞",
      en: "❝Herd immunity❞",
      position: "insideBottom",
    },
    {
      x: "2024-06-24",
      fr: "❝Un variant en été, on l'a toujours pas vu venir❞",
      en: "❝A new summer variant, we still didnt see it coming❞",
      position: "insideRight",
    },
    {
      x: "2024-10-14",
      fr: "❝Nouveau combo: double vague en série❞",
      en: "❝New combo: double serial wave❞",
      position: "insideRight",
    },
    {
      x: "2024-12-24",
      fr: "❝Nouveau combo: triple vague en série❞",
      en: "❝New combo: triple serial wave❞",
      position: "insideRight",
    },
    {
      x: "2024-01-30",
      fr: "❝gneu gneu saisonier etc❞",
      en: "❝gna gna seasonal etc❞",
      position: "insideRight",
    },
    {
      x: "2025-05-01",
      fr: "❝Même mon chien apprend plus vite de ses erreurs❞",
      en: "❝Even my dog learn faster from his mistakes❞",
      position: "insideRight",
    },
  ]

  return (
    <ResponsiveContainer
      width="90%"
      height="100%"
      minHeight={700}
      maxHeight={700}
    >
      <LineChart
        data={rangeFiltered}
        margin={{
          right: 30,
          left: 20,
        }}
      >
        {citiesName.map((city, index) => (
          <Line
            type="monotone"
            connectNulls
            dot={false}
            dataKey={city}
            className={!tempFilter?.includes(city) && "desactivated"}
            key={city}
            stroke={
              tempFilter?.includes(city)
                ? cityColors[index]
                : "rgb(122, 122, 122)"
            }
            styles={{
              opacity: rangeFiltered.some((week) =>
                Object.keys(week).includes(city),
              )
                ? 1
                : 0,
            }}
            strokeWidth={tempHover && tempHover.includes(city) ? 10 : 2}
            strokeDasharray={city === "national" ? "4 4" : "0 0"}
            name={city}
            id={city}
            isAnimationActive={true}
            animationDuration={100}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseOut}
          ></Line>
        ))}
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis tickMargin={5} dataKey={xAxis} />
        <YAxis
          scale={scaleChoice === "log" ? log : "auto"}
          domain={[0, Math.floor(zoomMax / 1000) * 1000 + 1000]}
          tickFormatter={(doo) => (doo > 1000 ? doo / 1000 + "K" : doo)}
          type="number"
          label={{
            value: french
              ? "Concentration virale cg/L"
              : "Viral concentration cg/L",
            angle: -90,
            position: "left",
            textAnchor: "middle",
          }}
          tick={({ x, y, width, height, payload }) => (
            <g>
              <rect
                x={x - 38}
                y={y - 10}
                width={width / 1.4}
                height={20}
                fill={levelToColor(payload.value)}
                rx={4}
              >
                {" "}
              </rect>
              <text
                orientation="left"
                width={width}
                height={height}
                stroke="none"
                x={x}
                y={y}
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end"
                fill="white"
              >
                <tspan x={x} dy="0.355em">
                  {payload.value > 1000
                    ? payload.value / 1000 + "K"
                    : payload.value}
                </tspan>
              </text>
            </g>
          )}
        ></YAxis>

        <text
          className="scale-switch"
          transform="rotate(-90)"
          x="-50"
          y="20"
          onClick={(event) => {
            event.preventDefault()
            setScaleChoice(scaleChoice === "log" ? "linear" : "log")
          }}
        >
          {scaleChoice}
        </text>

        <Legend
          width={97}
          align="center"
          wrapperStyle={{
            width: "98%",
            // margin: "auto",
          }}
          onMouseEnter={handleMouseOver}
          onMouseLeave={handleMouseOut}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onClick={handleclick}
          payload={citiesName.map((city, index) => ({
            dataKey: city,
            color: tempFilter?.includes(city)
              ? cityColors[index]
              : "rgb(122, 122, 122)",
            display: rangeFiltered.some((week) =>
              Object.keys(week).includes(city),
            ),
          }))}
          content={<CustomLegend />}
        />
        <Tooltip
          offset={40}
          contentStyle={{
            background: "rgb(33, 37, 43)",
            textAlign: "left",
          }}
          content={({ active, payload, label }) =>
            active &&
            payload &&
            label && (
              <div className="recharts-default-tooltip">
                <p className="recharts-tooltip-label">
                  {moment(label, french ? "YYYY-DD-MM" : "YYYY-MM-DD").format(
                    "DD MMMM YYYY",
                  )}
                </p>
                <ul className="recharts-tooltip-item-list">
                  {payload
                    .sort((first, second) => second.value - first.value)
                    .map(
                      (line, index) =>
                        line.value > 0 && (
                          <li
                            key={index}
                            className={
                              "recharts-tooltip-item " +
                              (tempHover.includes(line.name)
                                ? "recharts-tooltip-item-highlight"
                                : "")
                            }
                          >
                            <span
                              className="recharts-tooltip-item-circle"
                              style={{
                                background: line.color,
                              }}
                            ></span>{" "}
                            <span className="recharts-tooltip-item-name">
                              {line.name}
                            </span>{" "}
                            <span
                              className="recharts-tooltip-item-value"
                              style={{
                                background: levelToColor(line.value),
                              }}
                            >
                              {line.value}
                            </span>
                          </li>
                        ),
                    )}
                </ul>
              </div>
            )
          }
        />
        {scaleChoice === "linear" &&
          citiesName.length === showCity.length &&
          easters.map(({ x, position, fr, en }, index) => (
            <ReferenceLine
              key={index}
              x={moment(x, "YYYY-MM-DD").format(
                french ? "YYYY-DD-MM" : "YYYY-MM-DD",
              )}
              stroke="transparent"
              label={
                <Label
                  width={120}
                  offset={
                    (position === "insideTop" && 15) ||
                    (position === "insideBottom" && 70) ||
                    0
                  }
                  value={french ? fr : en}
                  position={position}
                />
              }
            />
          ))}
      </LineChart>
    </ResponsiveContainer>
  )
}
